import Card from "./Card";
import "../../shared/styles/index.css";

const Why_Cdgi = () => {
  return (
    <div className="cdgi-container">
      <p className="cdgi-container-heading">Why Choose CDGI?</p>
      <p className="cdgi-container-title">
        At Chameli Devi Group of Institutions, we don’t just offer degrees—we
        nurture dreamers, doers, and disruptors. Backed by the legacy of the
        renowned Agarwal Group and over 40 years of educational leadership, CDGI
        is your gateway to a future of innovation, industry, and impact.
      </p>

      <Card />
    </div>
  );
};

export default Why_Cdgi;
